import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from 'recharts';

interface TradeVolumeData {
  date: string;
  volume: number;
  trades: number;
}

interface TradeVolumeChartProps {
  data: TradeVolumeData[];
}

const TradeVolumeChart = ({ data }: TradeVolumeChartProps) => {
  return (
    <ResponsiveContainer width="100%" height={300}>
      <LineChart data={data}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="date" />
        <YAxis />
        <Tooltip />
        <Legend />
        <Line
          type="monotone"
          dataKey="volume"
          stroke="#3b82f6"
          strokeWidth={2}
          name="Volume"
        />
        <Line
          type="monotone"
          dataKey="trades"
          stroke="#10b981"
          strokeWidth={2}
          name="Trades"
        />
      </LineChart>
    </ResponsiveContainer>
  );
};

export default TradeVolumeChart;
